const ALLOWED_PUSH_ROUTES = new Set([
  "/atividade",
  "/conta",
  "/driver-home",
  "/motorista-analise",
  "/passenger-home",
]);

const ROUTE_BY_NOTIFICATION_TYPE = Object.freeze({
  corrida_cancelada: "/driver-home",
  corrida_concluida: "/atividade",
  lembrete_avaliacao: "/atividade",
  motorista_aceito: "/passenger-home",
  motorista_caminho: "/passenger-home",
  nova_corrida: "/driver-home",
});

export function resolvePushDestination(data = {}) {
  const requestedRoute = typeof data.tela === "string" ? data.tela.trim() : "";
  if (ALLOWED_PUSH_ROUTES.has(requestedRoute)) return requestedRoute;
  return ROUTE_BY_NOTIFICATION_TYPE[data.tipo] || null;
}
